export enum RoleTypeEnum {
    DEFAULT = 0,
    USER_ADMIN = 1,
    VENDOR_ADMIN = 2,
    SUPER_USER = 3,
};
